import React from 'react'

import { FeaturedPrice } from '../../../PriceLayout'
import OfferPriceAllIn from '../OfferPriceAllIn'
import type { OfferPriceProps } from '../types'

const OfferPriceAllInDaily = (props: OfferPriceProps) => {
  return <OfferPriceAllIn {...props} featuredPrice={FeaturedPrice.PerNight} />
}

export default OfferPriceAllInDaily
